import { useRef, useState } from "react";
import { Loading, decryptData, defaulUrl } from "../components/const";
import Swal from "sweetalert2";

const ModalImageProduct = ({ produit, onclose }) => {
    const [files, setFiles] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const closeRef = useRef();

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(selectedFiles);

        const previews = selectedFiles.map((file) => URL.createObjectURL(file));
        setPreviewUrls(previews);
    };

    const removeImage = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        const updatedPreviews = previewUrls.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        setPreviewUrls(updatedPreviews);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!files.length) {
            setErrors({ files: "Veuillez sélectionner au moins une image." });
            return;
        }

        setIsLoading(true);
        const formData = new FormData();
        // Ici pas besoin de formData.set("produit", produit.id) car l'id est dans l'URL
        files.forEach((file) => {
            formData.append("images[]", file); // Laravel attend un tableau "images[]"
        });

        fetch(`${defaulUrl}produits/${produit.id}/add-image`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + decryptData("ACCESS_TOKEN"),
                Accept: "application/json",
            },
            body: formData,
        })
            .then((res) =>
                res.json().then((data) => ({
                    status: res.status,
                    data,
                }))
            )
            .then(({ status, data }) => {
                setIsLoading(false);
                if (status === 200 || status === 201) {
                    Swal.fire({
                        icon: "success",
                        title: "Succès",
                        text: data.message,
                    }).then(() => {
                        closeRef.current.click();
                        setFiles([]);
                        setPreviewUrls([]);
                        setErrors({});
                    });
                } else {
                    setErrors(data.errors || {});
                }
            }).then(() => onclose())

            .catch((error) => {
                setIsLoading(false);
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    text: "Une erreur est survenue, veuillez réessayer.",
                });
            });
    };

    return (
        <div
            className="modal fade"
            id="image-product"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">Image du produit</h1>
                        <button
                            ref={closeRef}
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <form className="modal-body" onSubmit={handleSubmit}>
                        <div className="form-group mb-3">
                            <label htmlFor="product">Produit</label>
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={produit?.produit}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Image</label>
                            <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                multiple
                                onChange={handleFileChange}
                            />
                            {errors.files && <div className="text-danger">{errors.files}</div>}
                        </div>

                        {/* Aperçu des images avec bouton de suppression */}
                        {previewUrls.length > 0 && (
                            <div className="row g-2 mb-3">
                                {previewUrls.map((url, idx) => (
                                    <div key={idx} className="col-6 col-md-4 col-lg-3 position-relative">
                                        <img
                                            src={url}
                                            className="img-fluid rounded border"
                                            alt={`Aperçu ${idx}`}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                            onClick={() => removeImage(idx)}
                                            title="Supprimer cette image"
                                        >
                                            &times;
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}

                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Annuler
                            </button>
                            <button type="submit" className="btn btn-success ms-2" disabled={isLoading}>
                                {isLoading && <Loading />} Enregistrer
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ModalImageProduct;
